import React from 'react';
import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { ImageProps } from '../Image/types';

export const AuthorImage = ({
  as: Component = 'img',
  className,
  ...props
}: DefaultBsComponent & ImageProps) => {
  return (
    <Component
      {...props}
      className={classNames(
        'AuthorImage',
        'max-w-[35px] max-h-[35px] rounded-full overflow-hidden',
        'mr-8 lg:mr-16 object-cover object-center-top',
      )}
    />
  );
};
